import React from 'react';
import { AppLink } from '@finect/tabular-core/AppLink';
import { getProductReviewsPath, getProductDisplayName } from '@finect/front-resources/Products';
import { Link } from 'react-router-dom';
export var Reviews = function Reviews(_ref) {
  var product = _ref.product,
    value = _ref.value,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'explained' : _ref$variant;
  switch (variant) {
    case 'count':
      {
        return value.total;
      }
    case 'explained':
      {
        var title = "Ver opiniones sobre ".concat(getProductDisplayName(product));
        return React.createElement(AppLink, {
          as: Link,
          to: getProductReviewsPath(product),
          title: title
        }, value.total, " ", value.total !== 1 ? 'opiniones' : 'opinión');
      }
    default:
      {
        return null;
      }
  }
};